import * as config from "./config";

//获取图片码
export const getClient = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/captchaImage';

//登录
export const getlogin = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/login';
//注册
export const getregister = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/register';

//生成授权码
export const getAuthorizeCode = config.cpeosFixUrlAPI + '/yjcSystem/sys/trade_platform/authority_center/getAuthorizeCode';
//国家平台登录
export const cpeosLogin = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/user/cpeos/login';
//国家平台退出
export const cpeosLogout = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/cpeos/logout';


// 获取验证码
export const getSmsSend = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/sms/send';
// 获取发布需求验证码
export const getdemandSmsSend = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/demand/send';
// 变更手机号验证码
export const getupdateTEL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/change/tel/send';
// 变更手机号提交
export const updateTEL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/change/tel';


// 获取修改密码
export const getupdatePwdSmsSend = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/updatePwd/send';

// 获取用户信息
export const GETuserInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/getInfo';
// export const GETuserInfo = config.cpeosFixUrlAPI + '/sys/user/info';

// 获取省市区
export const provinceUrl = config.cpeosFixUrlAPI + '/yjcImage/administrative/province';
export const cityUrl = config.cpeosFixUrlAPI + '/yjcImage/administrative/city';

// 更新用户信息
export const setUserInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/cpeos/setUserInfo';
export const setUserInfo2 = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/system/user/profile';
// export const setUserInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/setUserInfo';
// 更新用户企业信息
export const setUserQYInfo = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/settled';
// 重置密码
export const updatePwd2 = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/system/user/profile/updatePwd';
// export const updatePwd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/cpeos/updatePwd';
// export const updatePwd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/user/updatePwd';
// 图片上传
export const fileUpload = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/file/upload';

// 获取省市区
export const getCityCode = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/area/listByPid';
// 查询卫星类别
export const satelliteALL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/satellite/list/all';
// 根据商品id 查详情
export const getShopGoodsDesc = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/v2/api/goods/get/';

// 查看购物车
export const getShoppingCart = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/shoppingCart/v2/queryItem';
// 修改购物车的商品数量
export const updateNumShoppingCart = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/shoppingCart/alterCount';
// 删除购物车内商品
export const delShoppingCart = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/shoppingCart/deleteItem';
// 批量收藏购物车内的商品
export const bulkCollectProduct = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/collect/batch/add';
// 首页平台相关统计数据
export const goodsindexcount = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goods/index/count';
// 某一商品评论
export const commentgetComment = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/comment/getComment';
//首页配置列表
export const HomePageConfiguration = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/home/config/list';
//查看轮播图
export const homeSwiper = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/carouselImageList?type=1';
//查看新闻信息
export const newsListURL = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/newsList';

// 导入批量商品信息
export const importBulkProducts = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/batch/save';
// 获取导入商品文件的数据 /{batchId}
export const getUploadData = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/batch/list/';
// 批量删除未发布产品
export const bulkDeleteUpload = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/batch/delete';
// 发布批量产品
export const publishUploadProduct = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/api/goods/batch/publish';
// 获取用户通知列表-
export const userNoticePage = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/userNotice/page';
// 通知信息--
export const userNoticeRead = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/userNotice/read';
// 删除用户通知文件-
export const userNoticeDelete = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/p/userNotice/delete';

// 添加访问总量
export const visitAdd = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/visit';


// 获取新闻资讯详细信息
export const visitNews = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/cms/news';


// 获取新闻资讯详细信息
export const getDictType = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/common/dict/data/type';

//  邮箱验证
export const sendVerifyEmail = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/sendVerifyEmail';
//  重置密码
export const resetPassword = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/resetPassword';


// 密码过期验证
export const checkPassword = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/client/check';

